import { Link } from "@/router";

const PACKS = [
  {
    name: "eContract package",
    price: "$15",
    per: "/ transaction",
    body: "Send, sign, and store contracts electronically, without paying for a platform you barely use.",
  },
  {
    name: "Invoice package",
    price: "$35",
    per: "/ transaction",
    body: "Bill accurately and get paid faster, with invoicing built to slot into how you already work.",
  },
  {
    name: "Loan onboarding",
    price: "$35",
    per: "/ customer",
    body: "Bring new borrowers on board with a guided flow, without building one yourself.",
  },
] as const;

export function Pricing() {
  return (
    <section id="services" className="k-band">
      <div className="k-shell k-sec">
        <p className="k-label">What you can hire us for</p>
        <h2>Services &amp; pricing</h2>

        <div className="k-rate">
          <div className="k-rate__main">
            <span className="k-chip k-chip--green">Hourly · Stage one</span>
            <h3>Hire a personal programmer</h3>
            {/*
              The analogy is the hero's job and it is not repeated here. By
              the time somebody has scrolled to the price they have agreed
              with the premise; what they need now is what the hour actually
              covers. "No incentive but the truth" is lifted from the mission
              copy on purpose — it is the whole proposition, and it belongs
              next to the number.
            */}
            <p>
              Security checks, SEO effectiveness, and a comprehensive review of
              the systems your customers depend on. Independent, with no
              incentive but the truth — and no obligation past the hour.
            </p>
          </div>

          <div className="k-rate__side">
            <p>
              <span className="k-rate__fig">$125</span>
              <span className="k-rate__unit">Per hour</span>
            </p>
            <Link className="k-btn k-btn--ink" href="/contact">
              Request a review
            </Link>
          </div>
        </div>

        <div className="k-packs">
          {PACKS.map((pack) => (
            <article key={pack.name} className="k-pack">
              <h3>{pack.name}</h3>
              <span className="k-pack__from">As low as</span>
              <p className="k-pack__price">
                <span className="k-pack__fig">{pack.price}</span>
                <span className="k-pack__per">{pack.per}</span>
              </p>
              <p>{pack.body}</p>
            </article>
          ))}
        </div>

        <div className="k-combine">
          <div>
            <h3>Combine all three</h3>
            <p>
              <span className="k-combine__path">
                eContract → Invoice → Loan Onboarding
              </span>
              , one connected path from signed contract to fully onboarded
              customer.
            </p>
          </div>
          <Link className="k-btn k-btn--ghost" href="/contact">
            Contact us for pricing
          </Link>
        </div>
      </div>
    </section>
  );
}
